module.exports = __webpack_public_path__ + "static/img/assetLogout.f11227fa.svg";